import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation SpaceRecordRemoveLabAssignment(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $assignmentId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceRecordRemoveLabAssignment(assignmentId: $assignmentId)
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.SpaceRecordRemoveLabAssignmentMutation,
  undefined,
  graphql.schema.SpaceRecordRemoveLabAssignmentMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
